import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { getHowItWorks, getTrustBadges } from '../../../mocks/pretAPorter';

export default function HowItWorks() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900 });

  return (
    <section ref={ref} className="w-full bg-brand-gray-50 py-20 md:py-28">
      <div className="px-6 lg:px-[7%]">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto" style={style}>
          <span className="font-sans text-brand-gray-400 text-[11px] tracking-[0.2em] uppercase font-medium">
            Cómo Funciona
          </span>
          <h2 className="font-serif text-brand-black text-[clamp(2rem,4vw,3rem)] font-semibold leading-[1.15] mt-4">
            Rápido, fácil y
            <span className="italic text-brand-gray-300"> sin complicaciones</span>
          </h2>
        </div>

        {/* Steps */}
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {getHowItWorks().map((step, index) => (
            <div
              key={step.step}
              className="bg-white rounded-[24px] p-8"
              style={isVisible ? {
                opacity: 1,
                transform: 'translateY(0px)',
                transition: `opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 140}ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 140}ms`,
              } : {
                opacity: 0,
                transform: 'translateY(36px)',
                transition: `opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 140}ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 140}ms`,
                willChange: 'opacity, transform',
              }}
            >
              <div className="w-12 h-12 rounded-full bg-brand-gray-50 flex items-center justify-center mb-5">
                <i className={`${step.icon} text-brand-black text-xl`} />
              </div>
              <span className="font-sans text-brand-gray-400 text-xs tracking-wider uppercase font-medium">
                Paso {step.step}
              </span>
              <h3 className="font-serif text-brand-black text-xl font-medium mt-2">
                {step.title}
              </h3>
              <p className="font-sans text-brand-gray-500 text-[14px] leading-[1.7] mt-3">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        {/* Trust Badges */}
        <div
          className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-4"
          style={isVisible ? {
            opacity: 1,
            transform: 'translateY(0px)',
            transition: 'opacity 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 700ms, transform 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 700ms',
          } : {
            opacity: 0,
            transform: 'translateY(20px)',
            transition: 'opacity 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 700ms, transform 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 700ms',
            willChange: 'opacity, transform',
          }}
        >
          {getTrustBadges().map((badge) => (
            <div
              key={badge.label}
              className="bg-white rounded-2xl p-6 flex items-center gap-4"
            >
              <div className="w-10 h-10 rounded-full bg-brand-sage flex items-center justify-center flex-shrink-0">
                <i className={`${badge.icon} text-brand-black text-lg`} />
              </div>
              <div>
                <span className="font-sans text-brand-black text-sm font-medium block">
                  {badge.label}
                </span>
                <span className="font-sans text-brand-gray-400 text-xs">
                  {badge.description}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}